import { getFromImmutableState } from 'src/utils/immutableUtils';

const _getImportantEvents = (state) => state.get('importantEvents');
export const getImportantEvents = getFromImmutableState(_getImportantEvents);
